import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import Image from "react-bootstrap/Image";
import { Button } from "react-bootstrap";

const ITEM_TYPE = "SESSION";

export default function SessionCard({
  session,
  index,
  activeSessionId,
  placeholderFrontImage,
  handleSessionClick,
  handleImageRemoveSession,
  handleImageChangeSession,
  handleFileInputReset,
  handleRemoveSession,
  setSessions,
  setForm,
  form,
  moveSession,
}) {
  const ref = useRef(null);

  // Drop target
  const [, drop] = useDrop({
    accept: ITEM_TYPE,
    hover(item) {
      if (item.index !== index) {
        moveSession(item.index, index);
        item.index = index;
      }
    },
  });

  // Drag source
  const [{ isDragging }, drag] = useDrag({
    type: ITEM_TYPE,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <li
      ref={ref}
      key={session.clientWorkoutPlanSessionId}
      className={`session-item ${
        activeSessionId === session.clientWorkoutPlanSessionId ? "active" : ""
      }`}
      style={{ opacity: isDragging ? 0.5 : 1, cursor: "grab" }}
      onClick={() => handleSessionClick(session.clientWorkoutPlanSessionId)}
    >
      <div>
        <div className="mx-3 mt-1 image-container-sessions position-relative profile-image-container">
          {session?.sessionPhotoBase64 ? (
            <Image
              src={`data:${session?.sessionPhotoFileType};base64,${session?.sessionPhotoBase64}`}
              alt="Profile Picture"
              className="w-100 h-100 rounded-3"
            />
          ) : (
            <Image
              src={placeholderFrontImage}
              alt="Default Profile"
              className="w-100 h-100 rounded-3 p-1"
            />
          )}

          {session?.sessionPhotoBase64 && (
            <Button
              variant="link"
              className="position-absolute m-2 p-0 icon-position-session"
              onClick={(e) => {
                e.stopPropagation();
                handleImageRemoveSession(session.clientWorkoutPlanSessionId);
              }}
            >
              <i
                className="bi bi-x-circle-fill"
                style={{ fontSize: "30px", color: "red" }}
              ></i>
            </Button>
          )}

          {!session?.sessionPhotoBase64 && (
            <Button
              variant="link"
              className="position-absolute m-2 p-0 icon-position-session"
              onClick={(e) => {
                e.stopPropagation();
                document
                  .getElementById(
                    `workoutsession-${session.clientWorkoutPlanSessionId}`
                  )
                  .click();
              }}
            >
              <i
                className="bi bi-plus-circle-fill"
                style={{ fontSize: "30px", color: "green" }}
              ></i>
            </Button>
          )}

          <input
            type="file"
            accept="image/*"
            id={`workoutsession-${session.clientWorkoutPlanSessionId}`}
            className="mt-2"
            onChange={(e) =>
              handleImageChangeSession(e, session.clientWorkoutPlanSessionId)
            }
            style={{ display: "none" }}
            onClick={() =>
              handleFileInputReset(
                `workoutsession-${session.clientWorkoutPlanSessionId}`
              )
            }
          />
        </div>
      </div>

      <input
        type="text"
        value={session.sessionName}
        onChange={(e) => {
          const updatedSessions = form?.clientWorkoutPlanSessionRequests?.map(
            (s) =>
              s.clientWorkoutPlanSessionId ===
              session.clientWorkoutPlanSessionId
                ? { ...s, name: e.target.value }
                : s
          );
          setSessions(updatedSessions);

          setForm((prevForm) => {
            const updatedSessions =
              prevForm?.clientWorkoutPlanSessionRequests?.map((sessions) => {
                if (
                  sessions.clientWorkoutPlanSessionId ===
                  session.clientWorkoutPlanSessionId
                ) {
                  return {
                    ...sessions,
                    sessionName: e.target.value,
                  };
                }
                return sessions;
              });

            return {
              ...prevForm,
              clientWorkoutPlanSessionRequests: updatedSessions,
            };
          });
        }}
        className="session-name-input"
      />

      <span
        className="remove-session"
        onClick={(e) => {
          e.stopPropagation();
          handleRemoveSession(session.clientWorkoutPlanSessionId);
        }}
      >
        X
      </span>
    </li>
  );
}
